import { useRef, useMemo, useEffect } from 'react';
import { printAST } from '@utils/ast';
import { typesetKatex } from '@utils/common';
import { iGuideHtmlToPrintAST } from './ast.content-to-ast.js';
import { printPrinters } from './ast.printers.js';
import { richtextStyles } from './molecule.context.style.js';
import { jsx } from 'react/jsx-runtime';

function TaskContext(props) {
  const ref = useRef(null);
  const content = useMemo(() => {
    const ast = iGuideHtmlToPrintAST(props.task.guide);
    return printAST(ast, printPrinters);
  }, [props.task.guide]);
  useEffect(() => {
    typesetKatex(ref);
  }, []);
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: richtextStyles,
    children: content
  });
}

export { TaskContext };
//# sourceMappingURL=molecule.context.js.map
